import axios from 'axios';
import { csrfToken } from '../utils/csrfToken';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { formatQueryParams } from '../utils/query-params';
const api = axios.create({ transformRequest: [data => decamelizeKeys(data), ...axios.defaults.transformRequest], transformResponse: [...axios.defaults.transformResponse, data => camelizeKeys(data)], headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() }, paramsSerializer(params) { return formatQueryParams(params); } });
export { api };
